<template>
	<div class="row">
		<!-- customar project  start -->
		<div class="col-xl-12">
			<div class="card">
				<div class="card-body">
					<div v-if="user_can_generate_code" class="mb-2" align="right">
						<button
							@click="showModal"
							class="btn btn-info"
							style="width: fit-content"
						>
							Generate Access Code
						</button>
					</div>
					<div class="table-responsive" id="printable">
						<table
							id="data-table"
							class="table table-bordered table-striped mb-0"
						>
							<thead>
								<tr>
									<th>S/N</th>
									<th style="text-wrap: auto">NAME OF ASSOCIATION</th>
									<th>ACRONYM</th>
									<th>LOGO</th>
									<th style="text-wrap: auto">PROTEM CHAIRMAN</th>
									<th style="text-wrap: auto">PROTEM SECRETARY</th>
									<th>Access Code <br />Generated At</th>
									<th>Portal <br />Last Login</th>
									<th>Days Left</th>
									<th>
										Application <br />
										STATUS
									</th>
									<th class="no-print">Action</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(party, index) in parties" :key="'p' + party.id">
									<td>{{ index + 1 }}.</td>
									<td style="text-wrap: auto">{{ party.description }}</td>
									<td>{{ party.abbreviation }}</td>
									<td>
										<img :src="party.logo" height="60px" width="60px" />
									</td>
									<td style="text-wrap: auto">
										{{ party.protem_chairman ?? "Not Provided" }}
									</td>
									<td style="text-wrap: auto">
										{{ party.protem_secretary ?? "Not Provided" }}
									</td>
									<td>
										{{ party.applied_date }}
									</td>
									<td>
										{{
											party.application_code
												? party.application_code.last_opened_at
												: null
										}}
									</td>
									<td class="text-center">
										{{
											party.application_code
												? party.application_code.days_left
												: null
										}}
									</td>
									<td class="text-center">
										<template v-if="party.application_code">
											<span
												class="badge"
												:class="getStatusBg(party.application_code.status)"
											>
												{{ party.application_code.status }}
											</span>
										</template>
										<template v-else>
											<span class="badge bg-danger"> No Code </span>
										</template>
									</td>
									<td class="no-print">
										<router-link
											:to="`/parties/${party.id}/details`"
											class="btn btn-info"
										>
											<i class="feather icon-eye"></i> View
										</router-link>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
		<!-- customar project  end -->

		<GenerateAccessCodeModal />
	</div>
</template>
<script>
import Swal from "sweetalert2";
import { mapGetters } from "vuex";
import { EventBus } from "@/utils/event_bus.js";
import { userHasPermission } from "@/utils/permissions";
import GenerateAccessCodeModal from "./Partials/GenerateAccessCodeModal.vue";

export default {
	components: {
		GenerateAccessCodeModal,
	},
	computed: {
		...mapGetters({
			parties: "parties/associations",
		}),
		user_can_generate_code() {
			return userHasPermission("party-registration-access");
		},
	},

	data() {
		return {
			isLoading: false,
		};
	},

	methods: {
		getParties() {
			this.$store.dispatch("parties/getPendingAssociationList");
			// .then(() => Datatable("#data-table"));
		},

		getStatusBg(status) {
			if (status === "In-Progress") {
				return "bg-info";
			}

			if (status === "Application Rejected") {
				return "bg-danger";
			}

			return "bg-warning";
		},

		generateCode() {
			Swal.fire({
				title: "Generate Code",
				icon: "info",
				showCancelButton: true,
				confirmButtonColor: "#29623c",
				cancelButtonColor: "#6c757d",
				confirmButtonText: "Yes, proceed",
				cancelButtonText: "Cancel",
				focusConfirm: false,
			}).then((result) => {
				if (result.isConfirmed) {
					this.isLoading = true;
					let payload = {
						party_id: this.$route.params.id,
						// deadline: result.value.deadline,
					};

					this.$store
						.dispatch("parties/generateApplicationCode", payload)
						.then((resp) => {
							if (resp.status_code === 201) {
								Swal.fire({
									icon: "success",
									title: "Success",
									text: resp.status_message, // + ": " + resp.data.code,
								});
								this.isLoading = false;
							} else {
								Swal.fire({
									icon: "error",
									title: "Error",
									text: resp.response.data.errors.message,
								});
								this.isLoading = false;
							}
						});
				}
			});
		},

		showModal() {
			EventBus.$emit("toggle-modal", "show");
		},
	},

	mounted() {
		this.getParties();
	},
};
</script>
<style scoped>
.bg-info {
	background-color: #29623c !important;
}
th {
	color: black;
	font-size: 14px;
	font-weight: 700;
}
</style>
